import lodashOmit from 'lodash-es/omit';
import lodashPick from 'lodash-es/pick';
import type { LocationQuery } from 'vue-router';

import type { ApiAuctionsListingParams, ApiDirectSalesListingParams } from '~/apiClient';
import { AlpFilterableState, DslpFilterableState } from '~/types/filters';

const alpToDslpState: Partial<Record<AlpFilterableState, DslpFilterableState>> = {
    [AlpFilterableState.Running]: DslpFilterableState.Open,
    [AlpFilterableState.Expired]: DslpFilterableState.Closed,
};

const dslpToAlpState: Partial<Record<DslpFilterableState, AlpFilterableState>> = Object.fromEntries(
    Object.entries(alpToDslpState).map(([a, b]) => [b, a])
);

const mapAlpToDslpState = (values: string[]): DslpFilterableState[] =>
    values.map(v => alpToDslpState[v as AlpFilterableState]).filter((v): v is DslpFilterableState => v !== undefined);

const mapDslpToAlpState = (values: string[]): AlpFilterableState[] =>
    values.map(v => dslpToAlpState[v as DslpFilterableState]).filter((v): v is AlpFilterableState => v !== undefined);

export const mapAlpToDslpFiltersQuery = (query: LocationQuery): LocationQuery => {
    const state = locationQueryAsStringArray(query[SLP_QUERY_KEYS['aState']]);
    const mappedState = mapAlpToDslpState(state);

    return { ...lodashOmit(query, [SLP_QUERY_KEYS['aState']]), [SLP_QUERY_KEYS['dsState']]: mappedState };
};

export const mapDslpToAlpFiltersQuery = (query: LocationQuery): LocationQuery => {
    const state = locationQueryAsStringArray(query[SLP_QUERY_KEYS['dsState']]);
    const mappedState = mapDslpToAlpState(state);

    return { ...lodashOmit(query, [SLP_QUERY_KEYS['dsState']]), [SLP_QUERY_KEYS['aState']]: mappedState };
};

export const mapAlpToDslpFiltersApiParams = (params: ApiAuctionsListingParams): ApiDirectSalesListingParams => {
    const mappedState = params.state && mapAlpToDslpState(params.state);

    return lodashOmit(lodashPick({ ...params, state: mappedState }, SLP_API_PARAM_KEYS), ['sortBy', 'sortOrder', 'itemsPerPage']);
};

export const mapDslpToAlpFiltersApiParams = (params: ApiDirectSalesListingParams): ApiAuctionsListingParams => {
    const mappedState = params.state && mapDslpToAlpState(params.state);

    return lodashOmit(lodashPick({ ...params, state: mappedState }, SLP_API_PARAM_KEYS), ['sortBy', 'sortOrder', 'itemsPerPage']);
};
